import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import HomePage from './components/pages/HomePage';
import CalendarPage from './components/pages/CalendarPage';
import MenuPage from './components/pages/MenuPage';
import EventsPage from './components/pages/EventsPage';
import InfoPage from './components/pages/InfoPage';
import AktualitasokPageRoute from './components/AktualitasokPageRoute';
import MovingInPage from './components/pages/MovingInPage';
import ApartmentsPage from './components/pages/ApartmentsPage';
import AboutUsPage from './components/pages/AboutUsPage';
import GalleryPage from './components/pages/GalleryPage';
import VirtualWalkPage from './components/pages/VirtualWalkPage';
import ContactPage from './components/pages/ContactPage';
import DocumentsPage from './components/pages/DocumentsPage';
import AdminPanel from './components/pages/AdminPanel';
import NotFoundPage from './components/pages/NotFoundPage';
import { useFacebookSdk } from './useFacebookSdk';

function FacebookSdk() {
  useFacebookSdk();
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <FacebookSdk />
      <ScrollToTop />
    <div className="App">
        {/* Navigation - Always visible (except for admin panel) */}
        {!window.location.pathname.startsWith('/napvirag-blpk') && <Navigation />}
        
        {/* Routes - Different pages */}
               <Routes>
                 <Route path="/" element={<HomePage />} />
                 <Route path="/naptar" element={<CalendarPage />} />
                 <Route path="/heti-etlap" element={<MenuPage />} />
                 <Route path="/esemenyek" element={<EventsPage />} />
                 <Route path="/dokumentumok" element={<DocumentsPage />} />
                 <Route path="/dokumentumok/:documentId" element={<DocumentsPage />} />
            <Route path="/informaciok" element={<InfoPage />} />
            <Route path="/informaciok/bejelentesek" element={<AktualitasokPageRoute />} />
            <Route path="/informaciok/bekoltozes" element={<MovingInPage />} />
            <Route path="/informaciok/apartmanok" element={<ApartmentsPage />} />
            <Route path="/informaciok/magunkrol" element={<AboutUsPage />} />
                 <Route path="/galeria" element={<GalleryPage />} />
                 <Route path="/virtualis-seta" element={<VirtualWalkPage />} />
                 <Route path="/elerhetosegek" element={<ContactPage />} />
                 <Route path="/napvirag-blpk" element={<AdminPanel />} />
                 {/* Catch all route for 404 - must be last */}
                 <Route path="*" element={<NotFoundPage />} />
               </Routes>
        </div>
    </Router>
  );
}

export default App;